import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    slidebannerList: [],
    slidebanner: null,
    links: null,
    meta: null,
    filter: {
      keyword: '',
      status: '',
      tab: null,
    },
  },

  mutations: {
    CLEAR_ALL(state) {
      state.slidebannerList = [];
      state.slidebanner = null;
      state.tab = null;
    },
    SET_SLIDEBANNERLIST(state, data) {
      state.slidebannerList = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_SLIDEBANNER(state, data) {
      state.slidebanner = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
    SET_META(state, data) {
      state.meta = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setMeta({ commit }, data) {
      commit('SET_META', data);
    },

    set_Slidebanner({ commit }, data) {
      commit('SET_SLIDEBANNER', data);
    },

    find({ commit, state }) {
      let url = `/banner-center?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('slidebanner'));
          return response.body;
        })
        .then((response) => {
          commit('SET_SLIDEBANNERLIST', response);
        });
    },

    findById({ commit }, id) {
      return http(`/banner-center/${id}`)
        .then((response) => response.body)
        .then(typeAs('slidebanner'))
        .then((item) => {
          commit('SET_SLIDEBANNER', item);
        });
    },

    destroy(_, id) {
      return http(`/banner-center/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/banner-center/${id}`, { method: 'PUT', data })
        : http('/banner-center', { method: 'POST', data });
      return request.then((response) => response.body);
    },

    changeStatus(_, {
      id, ...data
    }) {
      const request = http(`/banner-center/${id}/status`, { method: 'PUT', data });

      return request.then((response) => response.body);
    },
  },
};
